import { SESSION_LOGIN, SESSION_LOGOUT } from 'src/store/actions';

const initialState = {
  loggedIn: true,
  user: {
    first_name: 'Shen',
    last_name: 'Zhi',
    email: 'demo@devias.io',
    avatar: '/images/avatars/avatar_11.png',
    bio: 'Brain Director',
    role: 'ADMIN', // ['GUEST', 'USER', 'ADMIN']
  },
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SESSION_LOGIN: {
      return {
        ...initialState,
      };
    }

    case SESSION_LOGOUT: {
      return {
        ...state,
        loggedIn: false,
        user: {
          role: 'GUEST',
        },
      };
    }

    default: {
      return state;
    }
  }
};

export { sessionReducer };
